import React from "react";

const Close = props => (
  <svg viewBox="0 0 23 23" {...props}>
    <path
      d="M11.435 10.021L21.163.293a1 1 0 011.414 1.414l-9.728 9.728 9.728 9.728a1 1 0 01-1.414 1.414l-9.728-9.728-9.728 9.728a1 1 0 11-1.414-1.414l9.728-9.728L.293 1.707A1 1 0 111.707.293l9.728 9.728z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Close;
